import { render, staticRenderFns } from "./EventModalCatalogPackageLogo.vue?vue&type=template&id=0011d7ea"
import script from "./EventModalCatalogPackageLogo.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogPackageLogo.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogPackageLogo.vue?vue&type=style&index=0&id=0011d7ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports